angular.module('bizmetryApp').service('TelemetryAgentService', ['$http', 'CONFIG', '$q', function ($http, CONFIG, $q) {

  // 📘 Obtener todos los agentes para un profile y cuenta
  this.getAgents = function (profileId, accountId, cancelPromise, background) {
    return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-agents/agents/search', {
      params: {
        profile_id: profileId,
        account_id: accountId
      },
      timeout: cancelPromise,
      bmSkipLoader: !!background
    });
  };

  this.getAgentById = function (agentId, accountId) {
    return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-agents/agents/' + agentId, {
      headers: {
        'X-User-Account-Id': accountId
      }
    });
  };

  // 🧩 Instancias (pods/réplicas HA) de un agente — usado por details dialog,
  // metrics explorer y log viewer para el selector "Todas las instancias" / una puntual.
  this.getAgentInstances = function (agentId, accountId) {
    return $http.get(CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-agents/agents/' + agentId + '/instances', {
      headers: {
        'X-User-Account-Id': accountId
      }
    });
  };

  // 🔁 Reiniciar agente
  this.restartAgent = function (agentId) {
    return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/restart`);
  };

  // 🛑 Detener agente
  this.stopAgent = function (agentId) {
    return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/stop`);
  };

  this.deleteAgent = function (agentId, accountId) {
    return $http.delete(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}`, {
      headers: { 'X-User-Account-Id': accountId }
    });
  };

  this.getRuntimeInfo = function (agentId) {
    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/runtime-info`);
  };

  this.pingAgent = function (agentId) {
    return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/ping`);
  };

  // 📚 Función para obtener los logs de un agente
  // podName: null/undefined = todas las instancias; un podName puntual = solo esa instancia.
  this.fetchLogs = function (agentId, page, size, search, logLevel, podName) {
    const params = {
      page: page,
      size: size
    };

    if (search && search.trim() !== '') {
      params.searchText = search.trim();
    }

    if (logLevel && logLevel.trim() !== '') {
      params.level = logLevel.trim();
    }

    if (podName && podName.trim() !== '') {
      params.podName = podName.trim();
    }

    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/logs`, {
      params: params
    });
  };

  // 📊 Obtener métricas agregadas por intervalo para un agente
  // podName: null/undefined = todas las instancias; un podName puntual = solo esa instancia.
  this.getAggregatedMetrics = function (agentId, startTs, endTs, intervalSeconds, page, pageSize, podName, skipLoader) {
    const params = {
      startTs: startTs,
      endTs: endTs,
      intervalSeconds: intervalSeconds || 900,
      page: page !== undefined ? page : 0,
      size: pageSize || 20
    };

    if (podName) {
      params.podName = podName;
    }

    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/metrics`, {
      params: params, bmSkipLoader: !!skipLoader
    });
  };

  // 📅 Obtener el rango de tiempo disponible para las métricas de un agente
  // podName: null/undefined = todas las instancias; un podName puntual = solo esa instancia.
  this.getMetricsTimeRange = function (agentId, podName, skipLoader) {
    console.log('📞 TelemetryAgentService.getMetricsTimeRange:', agentId, podName);

    const params = {};
    if (podName) {
      params.podName = podName;
    }

    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/metrics/time-range`, { params: params, bmSkipLoader: !!skipLoader })
      .then(function (response) {
        console.log('✅ Time range received:', response.data);
        return response;
      })
      .catch(function (error) {
        console.error('❌ Error fetching time range:', error);
        throw error;
      });
  };

  // 🔍 Buscar agentes con filtros aplicados
  this.searchAgents = function (accountId, profileId, environmentId, envTypeId, status, isReachable, cancelPromise) {
    const params = {
      account_id: accountId,
      profile_id: profileId,
      environment_id: environmentId,
      status: status,
      envTypeId: envTypeId,
      isReachable: isReachable
    };

    const config = {
      headers: { 'X-User-Account-Id': accountId },
      params: params,
      timeout: cancelPromise
    };

    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/search`, config);
  };

  this.getAgentDetails = function (agentId) {
    return $http.get(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}`);
  };

  this.downloadAgent = function (agentId) {
    $scope.currentUser = JSON.parse(sessionStorage.getItem('user') || '{}');
    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/download`,
      null,
      { responseType: 'arraybuffer' }
    );
  };

  this.downloadAgentWithProgress = function (agentId, onProgress, abortController) {
    const deferred = $q.defer();

    console.log('>>>> DOWNLOADAGENTWITHPROGRESS. AGENTID=', agentId);

    const url = `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/download`;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.responseType = 'arraybuffer';

    const tokenInfo = JSON.parse(sessionStorage.getItem("authTokenInfo") || "null");
    const token = tokenInfo?.access_token;
    if (token) {
      xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    }

    function responseError(fallback) {
      try {
        const body = JSON.parse(new TextDecoder().decode(xhr.response));
        return body.message || body.error || fallback;
      } catch (_) {
        return fallback;
      }
    }

    xhr.onprogress = function (event) {
      if (typeof onProgress === 'function') {
        onProgress({
          pct: event.lengthComputable && event.total > 0
            ? Math.min(99, Math.round(event.loaded / event.total * 100)) : null,
          mbLoaded: (event.loaded / (1024 * 1024)).toFixed(1),
          mbTotal: event.lengthComputable ? (event.total / (1024 * 1024)).toFixed(1) : null
        });
      }
    };

    xhr.onload = function () {
      if (xhr.status !== 200) {
        deferred.reject(responseError(xhr.status === 401
          ? 'Unauthorized: Your session may have expired.'
          : `Download failed with status ${xhr.status}`));
        return;
      }
      const buffer = new Uint8Array(xhr.response || new ArrayBuffer(0));
      if (buffer.length < 4 || buffer[0] !== 0x50 || buffer[1] !== 0x4B ||
          buffer[2] !== 0x03 || buffer[3] !== 0x04) {
        deferred.reject(responseError('The server did not return a valid agent ZIP. No file was downloaded.'));
        return;
      }
      onProgress?.({
        pct: 100,
        mbLoaded: (buffer.length / (1024 * 1024)).toFixed(1),
        mbTotal: (buffer.length / (1024 * 1024)).toFixed(1)
      });
      deferred.resolve(xhr.response);
    };

    xhr.onerror = function () {
      deferred.reject('Download failed due to network error');
    };

    if (abortController && typeof abortController === 'object') {
      abortController.abort = () => {
        xhr.abort();
        deferred.reject('Download aborted by user');
      };
    }

    xhr.send();
    return deferred.promise;
  };

  this.validateAgentURL = function (agentURL) {
    return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/validate_url?url=${encodeURIComponent(agentURL)}`);
  };

  this.getPemInfo = function (pem) {
    return $http.post(`${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/get-pem-info`, pem);
  };

  this.validateKeys = function (privateKey, publicKey, privateKeyPassphrase) {
    const payload = {
      privateKey: privateKey,
      publicKey: publicKey,
      privateKeyPassphrase: privateKeyPassphrase
    };

    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/validate_keys`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    ).then(function (response) {
      console.log('Key validation successful:', response.data);
      return response.data;
    }).catch(function (error) {
      console.error('Key validation failed:', error);
      throw error;
    });
  };

  this.generateChainCert = function (hostname, isPceMode) {
    const payload = {
      hostname: hostname,
      isPceMode: isPceMode
    };

    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/generate-keypair?hostname=${hostname}&isPceMode=${isPceMode}`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    ).then(function (response) {
      console.log('Certificate chain generated successfully:', response.data);
      return response;
    }).catch(function (error) {
      console.error('Certificate chain generation failed:', error);
      throw error;
    });
  };

  this.saveAgentConfig = function (agent) {

    const mc = agent.monitoringConfig || {};

    console.log('>>> mc.cpu completo:', JSON.stringify(mc.cpu));

    const payload = {
      agentMaxDiskBufferSize: agent.agentMaxDiskBufferSize,
      agentMetricsDiskMaxFrames: agent.agentMetricsDiskMaxFrames,
      agentMaxMemBufferSize: agent.agentMaxMemBufferSize,
      agentSyncInterval: agent.agentSyncInterval,
      agentMaxPayloadSizeMb: agent.agentMaxPayloadSizeMb,
      agentBulkFetchBatchSize: agent.agentBulkFetchBatchSize,
      agentSafForwarderInitialCount: agent.agentSafForwarderInitialCount,
      agentSafForwarderMaxCount: agent.agentSafForwarderMaxCount,
      agentSafUploadInitialBatchSizeFrames: agent.agentSafUploadInitialBatchSizeFrames,
      agentSafUploadMaxBatchSizeFrames: agent.agentSafUploadMaxBatchSizeFrames,
      agentSafForwarderScaleDownPressureThresholdPct: agent.agentSafForwarderScaleDownPressureThresholdPct,
      agentSafForwarderScaleUpPressureThresholdPct: agent.agentSafForwarderScaleUpPressureThresholdPct,
      // "network_settings" (snake_case) — matches AgentUpdateRequestDTO's own
      // @JsonProperty key, unlike every sibling field above (this DTO's own
      // convention is otherwise camelCase to match the Java field name).
      network_settings: {
        connectTimeoutSeconds: (agent.networkSettings || {}).connectTimeoutSeconds,
        readTimeoutSeconds:    (agent.networkSettings || {}).readTimeoutSeconds,
        proxyEnabled:  !!(agent.networkSettings || {}).proxyEnabled,
        proxyHost:     (agent.networkSettings || {}).proxyHost,
        proxyPort:     (agent.networkSettings || {}).proxyPort,
        proxyScheme:   (agent.networkSettings || {}).proxyScheme,
        proxyUsername: (agent.networkSettings || {}).proxyUsername,
        // Blank unless the user typed a new one — the backend preserves the
        // existing stored password whenever this comes back blank (same
        // convention the interceptor's own proxy config used to follow).
        proxyPassword: (agent.networkSettings || {}).proxyPassword
      },
      agentLogLevel: agent.agentLogLevel,
      agentLogBufferSize: agent.agentLogBufferSize,
      agentLogBatchSize: agent.agentLogBatchSize,
      agentName: agent.agentName,
      isPubliclyExposed: agent.isPubliclyExposed,
      isInternallyExposed: agent.isInternallyExposed,

      securityConfig: {
        external: {
          host: agent.securityConfig?.external?.host,
          public: { certificates: agent.securityConfig?.external?.public?.certificates },
          privateKey: agent.securityConfig?.external?.privateKey,
          privateKeyPassphrase: agent.securityConfig?.external?.privateKeyPassphrase
        },
        internal: {
          host: agent.securityConfig?.internal?.host,
          public: { certificates: agent.securityConfig?.internal?.public?.certificates },
          privateKey: agent.securityConfig?.internal?.privateKey,
          privateKeyPassphrase: agent.securityConfig?.internal?.privateKeyPassphrase,
          networkTopology: agent.securityConfig?.internal?.networkTopology || null
        }
      },

      osConfig: {
        enabled: !!agent.osConfig?.enabled,
        agentOsTypeId: agent.osConfig?.agentOsTypeId || null,
        agentOsTypeName: agent.osConfig?.agentOsTypeName || '',
        agentIngressTypeId: agent.osConfig?.agentIngressTypeId || null,
        agentIngressTypeName: agent.osConfig?.agentIngressTypeName || '',
        registryURL: agent.osConfig?.registryURL || '',
        registryProject: agent.osConfig?.registryProject || '',
        registryUserName: agent.osConfig?.registryUserName || '',
        registryPassword: agent.osConfig?.registryPassword || '',

        // 🔹 [WORKLOAD MANAGEMENT] Capacity mode + réplicas + HPA thresholds + CPU assignment
        capacityMode: agent.osConfig?.capacityMode || null,
        fixedReplicas: agent.osConfig?.fixedReplicas ?? null,
        dynamicInitialReplicas: agent.osConfig?.dynamicInitialReplicas ?? null,
        dynamicMaxReplicas: agent.osConfig?.dynamicMaxReplicas ?? null,
        cpuThresholdPercent: agent.osConfig?.cpuThresholdPercent ?? null,
        memoryThresholdPercent: agent.osConfig?.memoryThresholdPercent ?? null,
        thresholdDurationMinutes: agent.osConfig?.thresholdDurationMinutes ?? null,
        minCpuAssignment: agent.osConfig?.minCpuAssignment ?? null,
        maxCpuAssignment: agent.osConfig?.maxCpuAssignment ?? null
      },

      // 🔹 [MONITORING] Estructura anidada que espera el backend:
      //   { set: { threshold, time }, reset: { threshold, time } }
      // El formulario usa el modelo plano (thresholdSet, thresholdClear, setTime, resetTime)
      // que aquí se re-mapea a la estructura de la API.
      monitoringConfig: {
        cpu: {
          enabled: !!mc.cpu?.enabled,
          alertingEnabled: !!mc.cpu?.alertingEnabled,            // ← agregado
          set: { threshold: mc.cpu?.thresholdSet ?? 95, time: mc.cpu?.setTime ?? 5 },
          reset: { threshold: mc.cpu?.thresholdClear ?? 60, time: mc.cpu?.resetTime ?? 5 }
        },
        memory: {
          enabled: !!mc.memory?.enabled,
          alertingEnabled: !!mc.memory?.alertingEnabled,         // ← agregado
          set: { threshold: mc.memory?.thresholdSet ?? 90, time: mc.memory?.setTime ?? 5 },
          reset: { threshold: mc.memory?.thresholdClear ?? 50, time: mc.memory?.resetTime ?? 5 }
        },
        latency: {
          enabled: !!mc.latency?.enabled,
          alertingEnabled: !!mc.latency?.alertingEnabled,        // ← agregado
          set: { threshold: mc.latency?.thresholdSet ?? 10000, time: mc.latency?.setTime ?? 5 },
          reset: { threshold: mc.latency?.thresholdClear ?? 5000, time: mc.latency?.resetTime ?? 5 }
        },
        pressure: {
          enabled: !!mc.pressure?.enabled,
          alertingEnabled: !!mc.pressure?.alertingEnabled,
          set: { threshold: mc.pressure?.thresholdSet ?? 80, time: mc.pressure?.setTime ?? 5 },
          reset: { threshold: mc.pressure?.thresholdClear ?? 50, time: mc.pressure?.resetTime ?? 5 }
        },
        alertConfiguration: {                                    // ← este tampoco viajaba
          alertingEnabled: !!mc.alertConfiguration?.alertingEnabled,
          alertEnableEmail: !!mc.alertConfiguration?.alertEnableEmail,
          alertEnableSMS: !!mc.alertConfiguration?.alertEnableSMS,
          alertUsers: Array.isArray(mc.alertConfiguration?.alertUsers)
            ? mc.alertConfiguration.alertUsers.map(u => ({
              id: u.id,
              email: u.email,
              mobile2FANumber: u.mobile2FANumber || null,
              // Kept as is: a disabled user stays a recipient but gets no alerts (null = enabled)
              userEnabled: u.userEnabled != null ? u.userEnabled : null
            }))
            : []
        }
      }
    };

    console.log('📦 TelemetryAgentService.saveAgentConfig payload:', payload);

    console.log('📦 payload.monitoringConfig.cpu.alertingEnabled:', payload.monitoringConfig.cpu.alertingEnabled);
    return this.patchAgent(agent.agentId, payload);
  };


  this.patchAgent = function (agentId, payload) {
    return $http.patch(CONFIG.BIZMETRY_BACKEND_URL + "/v1/api/bizmetry-agents/agents/" + agentId, payload);
  };

  // 📄 Fetch Swagger contract via remote agent
  this.fetchSwaggerContract = function (agentId, url) {
    return $http.post(
      `${CONFIG.BIZMETRY_BACKEND_URL}/v1/api/bizmetry-agents/agents/${agentId}/fetch-swagger`,
      { url: url },
      { headers: { 'Content-Type': 'application/json' } }
    );
  };

}]);